module.exports = __webpack_public_path__ + "img/platform.984a961b.png";